<div>Selected Dataset: &nbsp; <b> {{ service.datasetName() }} </b></div>
<hr>
<div>Filters:</div>

<kendo-filter [filters]="service.filterExpressions()" [value]="initialValue" (valueChange)="onFilterChange($event)">
</kendo-filter>

@if(service.filters().filters.length == 0) {
<div>
	<div class="filters-instructions" style="display: inline-block; max-width: 400px;">
		Add filters and then click the "Count the Rows" button to see how many rows match.
		Limit the row count to make your dashboard quick like a bunny.
	</div>
</div>
}
@else {
<div>
	<div class="filters-instructions">
		<ul>
			@for (detail of service.filterFieldDetails(); track $index) {
			<li>{{detail.group}}: <b>{{detail.label}}</b> - {{detail.desc}}</li>
			}
		</ul>
	</div>
</div>
}

@if(service.filtersAffect(); as affect) {
<div class="filters-affect">
	<div>Unfiltered Row Count: {{affect.unfilteredCount}}</div>
	<div>Filtered Row Count: {{affect.filteredCount}}</div>
</div>
}
@else {
<div>
	<button class="btn" (click)="service.determineFiltersAffect()">Count the Rows</button>
</div>
}